<template>
  <div class="workflow-management">
    <div class="page-content-wrapper">
      <div class="row g-2">
        <div class="col-12">
          <div class="card shadow border rounded-3 text-center">
            <div class="card-body">
              <label class="mb-2 fw-semibold text-muted fs-3">Workflow Management</label>
              <p class="text-xs text-muted">
                Configure and manage workflow services and reporting
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="card shadow border rounded-3">
            <div class="card-body pb-1">
              <div class="d-flex justify-content-center">
                <CustomTabs :tabs="tabs" v-model="active_tab"></CustomTabs>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div v-if="active_tab === 'overview'">
            <!-- Overview content goes here -->
            <OverviewComponent></OverviewComponent>
          </div>
          <div v-else-if="active_tab === 'service'">
            <!-- Service Settings content goes here -->
            <ServiceComponent></ServiceComponent>
          </div>
          <div v-else-if="active_tab === 'service_templates'">
            <!-- Service Templates content goes here -->
            <TemplateComponent></TemplateComponent>
          </div>
          <div v-else-if="active_tab === 'applications'">
            <!-- Customer Applications content goes here -->
            <CustomerApplicationComponent></CustomerApplicationComponent>
          </div>
          <div v-else-if="active_tab === 'reporting'">
            <!-- Dynamic Reporting content goes here -->
            <p>Dynamic Reporting</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTabs from "@/components/CustomTab/CustomTab.vue";
import { defineAsyncComponent } from "vue";
import LoadingSpinner from "@/components/LoadingSpinner/LoadingSpinner.vue";

export default {
  name: "WorkflowManagementComponent",
  components: {
    CustomTabs,
    OverviewComponent: defineAsyncComponent({
      loader: () =>
        import("./elements/overview_component/OverviewComponent.vue"),
      loadingComponent: LoadingSpinner,
      delay: 200,
    }),
    ServiceComponent: defineAsyncComponent({
      loader: () => import("./elements/service_component/ServiceComponent.vue"),
      loadingComponent: LoadingSpinner,
      delay: 200,
    }),
    TemplateComponent: defineAsyncComponent({
      loader: () =>
        import("./elements/template_component/TemplateComponent.vue"),
      loadingComponent: LoadingSpinner,
      delay: 200,
    }),
    CustomerApplicationComponent: defineAsyncComponent({
      loader: () =>
        import(
          "./elements/customer_application/CustomerApplicationComponent.vue"
        ),
      loadingComponent: LoadingSpinner,
      delay: 200,
    }),
  },
  data() {
    return {
      active_tab: "overview",
      tabs: [
        { label: "Overview", value: "overview" },
        { label: "Services", value: "service" },
        { label: "Templates", value: "service_templates" },
        { label: "Customer Applications", value: "applications" },
        { label: "Dynamic Reporting", value: "cost" },
      ],
    };
  },
  watch: {
    // Watch for changes in active_tab if needed
    active_tab(new_value) {
      // Store the active tab in localStorage
      localStorage.setItem("workflow_management_tab", new_value);
    },
  },
  async mounted() {
    // Load the active tab from localStorage if it exists
    const stored_tab = localStorage.getItem("workflow_management_tab");
    if (stored_tab) {
      this.active_tab = stored_tab;
    }

    const load_script = (src) =>
      new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        const check = () => {
        if (src.includes("apexcharts") && window.ApexCharts) {
          resolve();
        } else {
          setTimeout(check, 50);
        }
        };
        return check();
      }
      const s = document.createElement("script");
      s.src = src;
      s.async = false;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
      });

    await load_script("https://cdn.jsdelivr.net/npm/apexcharts");
    
  },
  beforeUnmount() {
    // Clean up any dynamically loaded scripts if necessary
    const scripts = [
      "https://cdn.jsdelivr.net/npm/apexcharts"
    ];
    scripts.forEach((src) => {
      const script = document.querySelector(`script[src="${src}"]`);
      if (script) {
        script.remove();
      }
    });
  },    
};
</script>

<style scoped>
.fw-semibold{
  font-weight: 600;
}
</style>
